import Reveal from "@/components/Reveal";
import { ShieldCheck } from "lucide-react";

export default function Guarantee() {
  return (
    <section id="garantia" data-testid="guarantee-section" className="relative py-24 lg:py-32 border-t border-white/5">
      <div className="absolute inset-0 bg-radial-blue opacity-30" />
      <div className="max-w-7xl mx-auto px-4 md:px-8 relative">
        <Reveal>
          <div className="font-stencil text-xs text-[#00A0A0] tracking-widest mb-4 text-center">09 / GARANTÍA</div>
        </Reveal>

        <Reveal delay={100}>
          <div className="max-w-5xl mx-auto text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 mb-10 border border-[#FFD700]/40 bg-[#FFD700]/5 rounded-full">
              <ShieldCheck className="w-9 h-9 text-[#FFD700]" strokeWidth={1.5} />
            </div>

            <h2 className="font-heading text-white text-4xl sm:text-5xl lg:text-6xl xl:text-7xl uppercase tracking-tight leading-[0.95]">
              SI NO TE
              <br />
              <span className="font-stencil text-[#00A0A0]">HACEMOS CRECER,</span>
              <br />
              SEGUIMOS TRABAJANDO.
            </h2>

            <Reveal delay={250}>
              <p className="mt-10 text-lg lg:text-xl text-white/65 max-w-2xl mx-auto leading-relaxed font-body">
                Sin letra pequeña ni objetivos imposibles. Si en 90 días no ves crecimiento real en{" "}
                <span className="text-white">visibilidad</span>, <span className="text-white">conversaciones</span> o{" "}
                <span className="text-white">ventas</span>, seguimos trabajando contigo{" "}
                <span className="text-white">sin coste adicional</span> hasta que lo veas.
              </p>
            </Reveal>

            <Reveal delay={400}>
              <div className="mt-12 inline-flex flex-col sm:flex-row items-center gap-4 sm:gap-6 px-6 py-4 border-y border-white/10">
                <div className="text-left">
                  <div className="font-stencil text-xs uppercase tracking-widest text-white/45 mb-1">Compromiso</div>
                  <div className="font-heading text-white text-xl">90 días para ver resultados</div>
                </div>
                <div className="hidden sm:block w-px h-10 bg-white/10" />
                <div className="text-left">
                  <div className="font-stencil text-xs uppercase tracking-widest text-white/45 mb-1">Si no llegan</div>
                  <div className="font-heading text-[#FFD700] text-xl">Seguimos sin cobrar</div>
                </div>
              </div>
            </Reveal>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
